
import { Injectable } from '@angular/core';
import { RequestHelperProvider, CryptoService, UtilServiceProvider, StorageServiceProvider } from '../_services/services';
import { Settings } from '../_models/settings/settings.model';
import { GatewayServiceProvider } from './gateway.service';
import utils from '../utils';
import { Helpers } from '../_models/helpers';
import Utils from '../utils';
import { WareHouseProConfig } from '../_models/warehouse-pro/warehouse-pro-config.model';
import { StorageKeys } from '../_constants';
const configRemoteURL = Utils.GetConfigurationRemoteServer();
@Injectable({
  providedIn: 'root' 
})
export class AppSettingsServiceProvider {
    public configRemoteURL = Utils.GetConfigurationRemoteServer();
    public warehouseProConfig: WareHouseProConfig = new WareHouseProConfig();
    constructor(
        private helper: RequestHelperProvider,
        private gatewayService: GatewayServiceProvider,
        private crypt: CryptoService,
        private storage: StorageServiceProvider) {

    }

    private GetAdminSessionId(callback) {
        this.gatewayService.resolveRemoteHeader((remote, customerKey, SessionID, uiDefId, tenantID) => {
            this.helper.Post((data) => {
                let settings = new Settings();
                settings.customerKey = customerKey;
                settings.datasetTenantId = tenantID;
                settings.remoteServer = remote;
                settings.uiDefKey = uiDefId;
                settings.gatewaySessionId = data.SessionID;
                localStorage.setItem('settings', JSON.stringify(settings));
                callback(data.SessionID)
            }, `${remote}/culturahub/RESTSecurityWebService/Authenticate`, {
                "Password": "TLJUFZIZQPB+u9y1mPfmSw==",
                "Username": "apiAdmin",
                "DeviceName": "HOPPER"
            }, customerKey,
                null, uiDefId,
                (error) => {
                    callback(error);
                }
            )
        });
    }

    private LogOffModularisSession(sessionId: any) {
        this.gatewayService.resolveRemoteHeader((remote, customerKey, SessionID, uiDefId, tenantID) => {
            this.helper.Post(
                (data) => { Helpers.LogInfo('sessionId logged off'); Helpers.LogInfo(data); },
                `${remote}/culturahub/RESTSecurityWebService/LogOff`,
                null,
                customerKey,
                sessionId,
                uiDefId,
                (error) => { Helpers.LogError('Error in sessionId logging off call'); Helpers.LogError(error); },
                false,
                true);
        });
    }
    public LogOffAgentSession() {
        let settings = this.storage.get(StorageKeys.Settings);
        if (settings && settings.agentSessionId) {
            this.LogOffModularisSession(settings.agentSessionId);
        }
    }
    public LogOffGatewaySession() {
        let settings = this.storage.get(StorageKeys.Settings);
        if (settings && settings.gatewaySessionId) {
            this.LogOffModularisSession(settings.gatewaySessionId);
        }
    }

    public GetAgentSessionId(agentUsername, agentEncPassword, callback, failedCallback) {
        this.gatewayService.resolveRemoteHeader((remote, customerKey, SessionID, uiDefId, tenantID) => {
            this.helper.Post((data) => {
                let settings = this.storage.get(StorageKeys.Settings);
                settings.agentSessionId = data.SessionID;
                if (settings)
                    settings.agentSessionDate = new Date().toLocaleDateString();
                localStorage.setItem('settings', JSON.stringify(settings));
                callback(data.SessionID)
            }, `${remote}/culturahub/RESTSecurityWebService/Authenticate`, {
                "Password": agentEncPassword,
                "Username": agentUsername,
                "DeviceName": "HOPPER"
            }, customerKey,
                null, uiDefId,
                (error) => {
                    failedCallback(error);
                }
            )
        });
    }
    public GetActivation(clientEmail, clientPassword, Appname): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            // clientPassword = encodeURIComponent(this.crypt.encryptString(clientPassword));
            clientEmail = clientEmail;
            clientPassword = encodeURIComponent(clientPassword);
            this.GetAdminSessionId((adminSessionId) => {

               // let url = `/culturahub/RESTCommandWebService/ExecuteServerCommand/ActivationsCommandProcessor/ActivateApp?AgentEmail=${clientEmail}&AgentPassword=${clientPassword}&AppName=${Appname}&AppVersion=1.0.0`;

               this.activateApp(clientEmail, clientPassword)
                   .then((data) => {
                       resolve(data);
                   })
                   .catch((error) => {
                       reject(error);
                   });
            });
        });
        return promise;
    }
     async activateApp(clientEmail, clientPassword): Promise<any> {
    
            return new Promise(async (resolve, reject) => {
                var settings = this.storage.get(StorageKeys.Settings);
                let SessionID = settings ? settings.agentSessionId : null;
                let customerKey = settings ? settings.customerKey : null;
                let body = {
                    "AgentEmail": clientEmail,
                    "AgentEncryptedPassword": clientPassword,
                }
                let remoteUrl = utils.GetSalesReviewRemoteServer();
    
                await this.helper.Post((data: any) => {
                    if (data) {
                        const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
                        resolve(parsedData);
                    }
                    else
                        reject('No Data Found!')
                }
                    , `${remoteUrl}/AgrisLicense/ActivateApp`
                    , body
                    , customerKey
                    , SessionID
                    , null
                    , (error: any) => {
                        reject(error);
                    },
                    false,
                    false,
                    false,
                    true
                );
            });
    }
    public GetNameIdTypes(): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentType = this.storage.AgentType;
            let settings = this.storage.get(StorageKeys.Settings);
            let tenantID = this.storage.getTenantID();

            let params = [];
            agentType == 'SQL' && tenantID ? params.push(`?where=<<NameIDType.TenantID>> eq '${tenantID.toLowerCase()}'`) : '';
            let url = `/culturahub/RESTActivityWebService/agris.relational/NameIDType`;
            params.forEach((param, i) => {
                url = `${url}${(i > 0) ? ' and ' : ''}${param}`
            });

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
                if (data) {
                    resolve(data);
                }
                else
                    reject('No Data Found!')
            }, (error) => {
                reject(error);
            }, tenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true|NameIDType.OrderBy|Order By <<NameIDType.Code>> ASC` : 'NameIDType.OrderBy|Order By <<NameIDType.Code>> ASC'}`);
        });
    }
    public GetDecimalPricision(): Promise<any> {
        let tenantId;
        let settings = this.storage.get(StorageKeys.DataSet);
        tenantId = settings.TenantID;
        return new Promise((resolve, reject) => {
            let url = `/culturahub/RESTCommandWebService/ExecuteServerCommand/SystemSetupProcessor/Precision?TenantID=${tenantId}`;
            this.helper.PostServerCommand(url, {}, (data) => {
                if (data && data.ResultObject && data.ResultObject.length > 0) {
                    resolve(data.ResultObject[0])
                }
                else {
                    reject(false);
                }
            }, (response) => {
                reject(response.error);
            }, true);
        });
    }

    public async GetBookingPrograms(): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentType = this.storage.AgentType;
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenantId = this.storage.get(StorageKeys.DataSet).TenantID;
            let agentId = this.storage.AgentID;
            let userId = this.storage.get(StorageKeys.AgrisLicense).username;


            let body = {
                AgentId: agentId,
                TenantId: tenantId,
                UserId: userId,
                Type: "BookingProgramSettings"
            };

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            let remoteUrl = utils.GetSalesReviewRemoteServer();
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

            this.helper.Post(
                (data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${remoteUrl}/Settings/GetAppSettings`
                // , `salesreviewctd.agris.com/microservice/api/Settings/GetAppSettings`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }

    public async GetPendingAgreementSettings(): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentType = localStorage.getItem('AgentType');
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenantId = this.storage.get(StorageKeys.DataSet).TenantID;
            let agentId = localStorage.getItem('AgentId');
            let userId = JSON.parse(localStorage.getItem("agrisLicense")).username;


            let body = {
                AgentId: agentId,
                TenantId: tenantId,
                UserId: userId,
                Type: "PendingAgreementsConfiguration"
            };

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            let remoteUrl = utils.GetSalesReviewRemoteServer();
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

            this.helper.Post(
                (data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${remoteUrl}/Settings/GetAppSettings`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }

    public async GetAppSettingsFromASR(settingType: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentType = localStorage.getItem('AgentType');
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenantId = this.storage.get(StorageKeys.DataSet).TenantID;
            let agentId = localStorage.getItem('AgentId');
            let userId = JSON.parse(localStorage.getItem("agrisLicense")).username;


            let body = {
                AgentId: agentId,
                TenantId: tenantId,
                UserId: null,
                Type: settingType
            };

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            let remoteUrl = utils.GetSalesReviewRemoteServer();
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

            this.helper.Post(
                (data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${remoteUrl}/Settings/GetAppSettings`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }


    public getModules(): Promise<any> {

        return new Promise((resolve, reject) => {
            let agentType = localStorage.getItem('AgentType');
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenantId = this.storage.get(StorageKeys.DataSet).TenantID;
            let agentId = localStorage.getItem('AgentId');
            let userId = JSON.parse(localStorage.getItem("agrisLicense")).username;
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            let remoteUrl = `${utils.GetConfigurationRemoteServer()}/Modules`;
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
            this.helper.Get(remoteUrl, customerKey, SessionID, null, (response) => {
                resolve(response);
            }, (error: any) => {
                reject(error);
            }, tenantId, null
            );
        });
    }

    public getConfigurations(moduleId: any): Promise<any> {
        let self = this;
        return new Promise(function (resolve, reject) {
            let agentType = localStorage.getItem('AgentType');
            let settings = self.storage.get(StorageKeys.Settings);
            let dataSet = self.storage.get(StorageKeys.DataSet);
            let tenantId = self.storage.get(StorageKeys.DataSet).TenantID;
            let agentId = localStorage.getItem('AgentId');
            let userId = JSON.parse(localStorage.getItem("agrisLicense")).username;
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            // let remoteUrl = `${utils.GetConfigurationRemoteServer()}/ModuleConfigurations?ModuleId=${moduleId}&Agent=${agentId}&Dataset=${tenantId}`;
            let remoteUrl = `${utils.GetConfigurationRemoteServer()}/ModuleConfigurations?ModuleId=${moduleId}&Agent=${agentId}`;

            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

            self.helper.Get(remoteUrl, customerKey, SessionID, null, (response) => {
                resolve(response);
            }, (error: any) => {
                reject(error);
            }, tenantId, null
            );
        });
    }

    public async GetWareHouseStaggingSettings(settingType: string): Promise<any> {
        //const configRemoteURL = configRemoteURL;
        return new Promise((resolve, reject) => {
            let agentType = localStorage.getItem('AgentType');
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenantId = this.storage.get(StorageKeys.DataSet).TenantID;
            let agentId = localStorage.getItem('AgentId');
            let userId = JSON.parse(localStorage.getItem("agrisLicense")).username;


            let body = {
                AgentId: agentId,
                TenantId: tenantId,
                UserId: null,
                Type: settingType
            };

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            let remoteUrl = utils.GetSalesReviewRemoteServer();
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

            this.helper.Post(
                (data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${configRemoteURL}/Settings/GetAppSettings`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }
}



